import React, { useRef, useState } from "react";
import "./contact.css";
import gmail from "../../img/gmail.png";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mriaezw",
        "template_hqd7w6w",
        formRef.current,
        "enVSAlrG0oVHGCR8n"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">CONTACT ME!</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img
                src="https://cdn-icons-png.flaticon.com/512/552/552489.png"
                alt=""
                className="c-icon"
              />
              +91 9654690667
            </div>
            <div className="c-info-item">
              <img src={gmail} alt="" className="c-icon" />
              jayagarwal2003@gmail.com
            </div>
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>FOUND MY SKILLS INTERESTING?</b> Get in touch with me to
            collaborate.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input type="text" placeholder="Name" name="user_name" />
            <input type="text" placeholder="Subject" name="user_subject" />
            <input type="text" placeholder="Email" name="user_email" />
            <textarea
              name="message"
              placeholder="Message"
              cols="30"
              rows="10"
            />
            <button className="btbt">Submit</button>

            {done && "THANKYOU!"}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
